export function Footer({ setView }) {
  return (
    <footer className="flex flex-row gap-8 justify-start items-center w-full">
      <p className="text-xs font-thin  ">
        © {new Date().getFullYear()} - All Rights Reserved.
      </p>
    </footer>
  );
}
